import enLang from "./entries/en-US";
import esLang from "./entries/es_ES";
import plLang from "./entries/pl_PL";
import deLang from "./entries/de_DE";

const AppLocale = {
   en: enLang,
   pl: plLang,
   sp: esLang,
   de: deLang
};

export default AppLocale;
